import classnames from 'classnames'
import React from 'react'

import styles from './Field.module.scss'

type FieldProps = {
  label?: string
  hasError?: boolean
  disabled?: boolean
  children?: React.ReactNode
} & React.HTMLAttributes<HTMLDivElement>

export default React.memo(
  React.forwardRef<HTMLDivElement, FieldProps>(function Field(
    { label, hasError, disabled, children, className, ...htmlProps },
    ref
  ) {
    return (
      <div
        ref={ref}
        className={classnames(styles.Field, className)}
        {...htmlProps}
        data-has-error={hasError || undefined}
        data-disabled={disabled || undefined}
      >
        {children}
        <fieldset aria-hidden="true">{label && <legend>{label}</legend>}</fieldset>
      </div>
    )
  })
)
